var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SnackbarV1 from './V1';
import SnackbarV2 from './V2';
class SnackbarVersioned extends Component {
    componentDidMount() {
        if (this.props.version === 1)
            console.warn('Snackbar V1 is not a part of Momentum UI. We recommend you to use Snackbar V2 instead.');
    }
    getSnackbarByVersion() {
        const { version } = this.props;
        return [null, SnackbarV1, SnackbarV2][version];
    }
    render() {
        const Snackbar = this.getSnackbarByVersion();
        const _a = this.props, { version } = _a, rest = __rest(_a, ["version"]);
        return <Snackbar {...rest}/>;
    }
}
SnackbarVersioned.propTypes = {
    version: PropTypes.number.isRequired,
};
SnackbarVersioned.defaultProps = {
    version: 2,
};
export default SnackbarVersioned;
